import React from "react";
import { useTranslation } from "react-i18next";
import BookingForm from "../components/BookingForm";

export const BookingPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="pt-16 bg-gray-900 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-6">
            {t("1292", "Book Your Taxi")}
          </h1>
          <p className="text-lg text-gray-300">
            {t(
              "1293",
              "Professional taxi service to and from Schiphol Airport and throughout the Netherlands"
            )}
          </p>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-xs border border-gray-700 rounded-2xl shadow-2xl p-8">
          <BookingForm />
        </div>
      </div>
    </div>
  );
};
